import { render, staticRenderFns } from "./returnManageDetails.vue?vue&type=template&id=614719b1&scoped=true"
import script from "./returnManageDetails.vue?vue&type=script&lang=js"
export * from "./returnManageDetails.vue?vue&type=script&lang=js"
import style0 from "./returnManageDetails.vue?vue&type=style&index=0&id=614719b1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614719b1",
  null
  
)

export default component.exports